<template>
  <div>
    <load-block :load="load"/>
    <card :title="title">
      <dynamic-generator-form
        :form="loadData"
        v-if="loadData"
        :configData="configData"
        :isCreateForm="false"
        pageMode="true"
      />

      <div class="buttons-container">
        <l-button type="success" wide @click="fetchData">
          <span class="btn-label">Найти</span>
        </l-button>
        <l-button type="warning" wide @click="fetchDataForYesterday">
          <span class="btn-label">Найти за вчера</span>
        </l-button>
      </div>
      <div v-if="reportTablesData && reportTablesData.length > 0" class="reports-section">
        <div v-for="(row, index) in  reportTablesData" :key="index">
          <div v-if="row.data.length">
            <h2 class="section-title">{{ row.label }}</h2>
            <l-table :columns="row.columns" :data="row.data"></l-table>
          </div>
        </div>
      </div>

      <div v-if="!load" class="chart-reports-section">
        <div v-for="(row, index) in  tableDataAvgTime" :key="index">
          <div v-if="row.data.length">
            <h2 class="section-title">{{ row.label }}</h2>
            <l-table :columns="row.columns" :data="row.data"></l-table>
          </div>
        </div>
        <div class="chart-container">
          <ReportsChart :data="chartDataAvgTime"/>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import LTable from './ReportTable.vue';
import {mapAvgTimeToStackedSeries, mapReportToTableData, reportConfigData} from "./utils";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import TheEditPage from "../../../TheEditPage.vue";
import LoadBlock from "../../../shared/LoadBlock.vue";
import ChartCard from "../../../shared/Cards/ChartCard.vue";
import {API_METHODS} from "../../../../constant";
import {ApiService} from "@/util/ApiService";
import ReportsChart from "./ReportChart.vue";

export default {
  name: "ReportsPage",
  components: {ReportsChart, LoadBlock, TheEditPage, CommonPageEdit, LTable, ChartCard},
  computed: {
    title() {
      return this.$t("Автоматическая генерация отчетов");
    }
  },
  data() {
    return {
      chartDataAvgTime: [],
      tableDataAvgTime: [],
      load: false,
      reportTablesData: null,
      configData: reportConfigData,
      loadData: {
        kpp: null,
        inn: null,
        dateFrom: (new Date()).setHours(0, 0, 0, 0),
        dateTo: new Date(),
      },
      columns: ["", "Всего", "Успешные", "Ошибки"],
      columnsErrors: ["Группа ошибки", "Всего", "Успешные", "Ошибки"],
      companyColumns: ["Компания (ИНН | КПП)", "Всего", "Успешные", "Ошибки"],
      columnsTime: ["", "миллисекунд"],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchDataForYesterday() {
      const startOfYesterday = this.$moment().startOf('day').subtract(1, 'day').toDate()
      const now = this.$moment().toDate()
      this.$set(this.loadData, 'dateFrom', startOfYesterday)
      this.$set(this.loadData, 'dateTo', now)
      await this.fetchData()
    },

    async fetchData() {
      try {
        this.load = true;
        const res = await ApiService(API_METHODS.GET_REPORTS, this.getParams());
        const mapped = mapReportToTableData(res && res.object ? res.object : {});
        this.reportTablesData = this.composeReportTablesData(mapped);
      } catch (e) {
      } finally {
        this.load = false;
      }
    },

    composeReportTablesData(mapped) {
      this.tableDataAvgTime = [
        {label: 'Разрез по времени загрузки', columns: this.columns, data: mapped.tableDataTime || []},
      ]
      this.chartDataAvgTime = mapAvgTimeToStackedSeries(this.tableDataAvgTime)
      return [
        {label: 'Разрез по персонам', columns: this.columns, data: mapped.tableData || []},
        {label: 'Разрез по кодам', columns: this.columns, data: mapped.tableDataCodes || []},
        {label: 'Разрез по ошибкам/группам ESB → Corteos',
          columns: this.columnsErrors,
          data: mapped.tableDataGroupedEsbToCorteos || []},
        {
          label: 'Разрез по компаниям по персонам',
          columns: this.companyColumns,
          data: mapped.tableDataCompanyPerson || []
        },
        {
          label: 'Разрез по компаниям по кодам',
          columns: this.companyColumns,
          data: mapped.tableDataCompanyCodes || []
        },
        {
          label: 'Разрез по среднему времени загрузки 1 персоны',
          columns: this.columnsTime,
          data: mapped.tableDataAvgTime || []
        },
      ];
    },

    getParams() {
      const currentInn = this.loadData.inn
      const currentKpp = this.loadData.kpp
      const normalizedInn = (currentInn !== undefined && currentInn !== null &&
        String(currentInn).trim() !== '') ? String(currentInn) : ''
      const normalizedKpp = (currentKpp !== undefined &&
        currentKpp !== null && String(currentKpp).trim() !== '') ? String(currentKpp) : ''
      this.$set(this.loadData, 'inn', normalizedInn)
      this.$set(this.loadData, 'kpp', normalizedKpp)
      return {
        inn: normalizedInn || null,
        kpp: normalizedKpp || null,
        lang: this.$store.state.common.lang,
        dateFrom: this.loadData.dateFrom ?
          this.$moment.parseZone(this.loadData.dateFrom).utc(true).format() :
          null,
        dateTo: this.loadData.dateTo ?
          this.$moment.parseZone(this.loadData.dateTo).utc(true).format() :
          null,
      }
    }
  }
}

</script>
<style scoped>
.reports-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
}

.reports-section > div:last-child {
  grid-column: span 2;
}

.section-title {
  margin-bottom: 24px;
  font-weight: 400;
  color: #90AAB7;
  font-size: 12px;
  text-transform: uppercase;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.chart-container {
  margin-top: 24px;
}

.chart-reports-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
}

@media (max-width: 768px) {
  .reports-section, .chart-reports-section {
    grid-template-columns: 1fr;
  }

  .reports-section > div:last-child {
    grid-column: span 1;
  }
}
</style>
